/* ------------------------------------
	Anchor Link Smooth Scrolling
*/
jQuery(document).ready(function($) {
	$('a.anchor').click(function(){
		$('html, body').animate({
			scrollTop: $( $(this).attr('href') ).offset().top-180
		}, 500);
		return false;
	});

    var urlHash = window.location.href.split("#")[1];
    if (urlHash &&  $('#' + urlHash).length )
          $('html,body').animate({
              scrollTop: $('#' + urlHash).offset().top-120
          }, 700);
});

/* ------------------------------------
	Sticky Header
*/
window.onscroll = function() {
	stickyHeader();
};

var header = document.querySelector(".header");
var sticky = header.offsetTop;

function stickyHeader() {
	if (window.pageYOffset > sticky) {
		header.classList.add("sticky");
	} else {
		header.classList.remove("sticky");
	}
}

/* ------------------------------------
	Mobile Nav
*/
jQuery(document).ready(function($) {
	$('.mobile-menu .menu-item-has-children').each(function(i, obj) {
	    $(this).append('<span class="expand-this"><i class="fas fa-plus"></i></span>');
	});

	$('.expand-this').click(function() {
		$(this).siblings('.sub-menu').toggleClass('is-open');
		$(this).parent().toggleClass('child-open');
		$(this).siblings('.sub-menu').slideToggle('fast');

		if ( $(this).siblings('.sub-menu').hasClass('is-open') ) {
			$(this).html('<i class="fas fa-minus"></i>');
		} else {
			$(this).html('<i class="fas fa-plus"></i>');
		}
	});
});

function openNav() {
    document.getElementById("mobile-menu").style.width = "300px";
    document.getElementById("mobile-menu").style.right = "0px";
}

function closeNav() {
    document.getElementById("mobile-menu").style.width = "0";
    document.getElementById("mobile-menu").style.right = "-10px";
}

/* Storage Options Accordions */
jQuery(document).ready(function($) {

	/* On Click to Hide Bar */
	$('.accordion-item').click(function(){

		if ( $(this).hasClass('is-active') ) {
			$(this).children('.accordion-text').slideToggle();
			$(this).removeClass('is-active');

		} else {

			$(this).children('.accordion-text').slideToggle();
			$(this).addClass('is-active');

			if ( $(this).siblings('.accordion-item').hasClass('is-active') ) {
				$(this).siblings('.accordion-item').children('.accordion-text').slideUp();
				$(this).siblings('.accordion-item').removeClass('is-active');
			}

		}

	});

});

/* Basic Accordion - FAQs */
jQuery(document).ready(function($) {

	/* On Click to Hide Bar */
	$('.faq-item').click(function(){

		$(this).toggleClass('is-active');
		$(this).children('.faq-text').slideToggle();

	});

});

/* Close Locations Map Popup */
jQuery(document).ready(function($) {

	// Hide Map on Close X
	$( '#my_map_results' ).on( 'click', 'button', function () { 

		$('#my_map_results').hide();
		$('#my_map_container').hide();
		$('body').removeClass('hide-scrollbars');
		
	});

});